// File containing utility functions for calculating pixel metrics.

export function getHealthyMindRevenueMetrics(order: JsonObject) {
  const erev9 = order.erev_9_months;
  const eltv13 = order.eltv_13_months;
  return { eltv13, erev9 };
}
